import { render, staticRenderFns } from "./SwitchingPeriodModal.vue?vue&type=template&id=35902e37&scoped=true&"
import script from "./SwitchingPeriodModal.vue?vue&type=script&lang=js&"
export * from "./SwitchingPeriodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35902e37",
  null
  
)

export default component.exports